import React from "react";
import RubberBand from "react-reveal/RubberBand";
import Fade from "react-reveal/Fade";
import { TechstackList } from "../../utils/TechstackList";

const Techstack = () => {
  return (
    <section
      id="techstack"
      className="py-20 px-4 bg-gradient-to-br from-blue-50 to-indigo-50
        dark:from-[#0a0a18] dark:to-[#0f0f1a] transition-colors duration-300"
    >
      <div className="max-w-6xl mx-auto">
        <RubberBand>
          <div className="text-center mb-14">
            <h2
              className="text-3xl font-extrabold uppercase tracking-widest
                text-gray-800 dark:text-white mb-3"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Technologies Stack
            </h2>
            <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-[#f29f67] to-[#3b8ff3] mb-4" />
            <p className="text-gray-500 dark:text-gray-400 text-sm max-w-xl mx-auto">
              👉 Programming languages, frameworks, databases, front-end and back-end tools, and APIs
            </p>
          </div>
        </RubberBand>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {TechstackList.map((tech) => (
            <Fade left key={tech._id}>
              <div
                className="group flex flex-col items-center gap-2 p-4 rounded-2xl cursor-pointer
                  bg-white/90 dark:bg-white/5
                  border border-gray-200 dark:border-white/10
                  hover:border-[#f29f67]/40 dark:hover:border-[#f29f67]/40
                  hover:bg-[#f29f67]/5 dark:hover:bg-[#f29f67]/5
                  hover:shadow-lg hover:shadow-[#f29f67]/10
                  hover:-translate-y-1 transition-all duration-300"
              >
                <div className="text-3xl group-hover:scale-110 transition-transform duration-300
                  text-gray-700 dark:text-gray-200">
                  <tech.icon />
                </div>
                <span className="text-xs font-semibold text-gray-700 dark:text-gray-300
                  text-center group-hover:text-[#f29f67] transition-colors duration-200">
                  {tech.name}
                </span>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Techstack;